import { permissions } from "@pages/layouts/utils/Permissions.lists";

export const rulesMiddleware = (store) => (next) => (action) => {
  if (action?.rules) {
    const rules = action.rules;

    let allowedPermissions = getAllowedPermissions(rules);

    const { userConnected } = store.getState();
    if (
      userConnected?.permissions?.some((p) => allowedPermissions.includes(p))
    ) {
      return next(action);
    }
    return;
  }
  return next(action);
};

function getAllowedPermissions(rules) {
  if (!rules) {
    return [];
  }

  if (typeof rules === "string") {
    return permissions[rules] || [];
  }

  if (Array.isArray(rules)) {
    return rules;
  }

  if (typeof rules === "object" && rules?.employee && rules?.enterprise) {
    return [
      ...getAllowedPermissions(rules.employee),
      ...getAllowedPermissions(rules.enterprise)
    ];
  }

  return [];
}
